module.exports = [
	{
		"oRating": "Standard",
		"Death": "1",
		"TPD": "1",
		"IP": "1"
	},
	{
		"oRating": "Professional",
		"Death": "0.65",
		"TPD": "0.55",
		"IP": "0.65"
	},
	{
		"oRating": "White collar",
		"Death": "0.7",
		"TPD": "0.65",
		"IP": "0.75"
	},
	{
		"oRating": "High risk",
		"Death": "1.4",
		"TPD": "2.9",
		"IP": "1.3"
	}
];


//////////////////
// WEBPACK FOOTER
// C:/git/qsuper-fed/~/json-loader!./src/data/occupationalRating.json
// module id = 452
// module chunks = 0